/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } =
    theme
  const { active, transparentSidenav } = ownerState

  const { dark, white, text, transparent, parco } = palette
  const { xxl } = boxShadows
  const { borderRadius } = borders
  const { pxToRem } = functions

  return {
    background: active ? '#f1f1f1' : 'transparent',
    color: active ? '#595B59' : '#A3A7AA',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontWeight: '700',
    padding: `${pxToRem(10)} ${pxToRem(30)} `,
    // fontSize: '18px',
    marginBottom: '10px',
    // margin: `0 ${pxToRem(8)} ${pxToRem(4)}`,
    borderRadius: '24px',
    cursor: 'pointer',
    userSelect: 'none',
    whiteSpace: 'nowrap',

    // boxShadow: active && transparentSidenav ? xxl : 'none',
    '&:hover': {
      background: '#f1f1f1',
      color: '#595B59',
    },
    '&:hover span': {
      color: '#595B59',
    },
    '&:hover svg, &:hover svg g': {
      fill: '#595B59',
    },
  }
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } =
    theme
  const { active, transparentSidenav, sidenavColor } = ownerState

  const { white, info, light, gradients, parco } = palette
  const { md } = boxShadows
  const { borderRadius } = borders
  const { pxToRem } = functions

  return {
    background: () => {
      if (active) {
        return sidenavColor === 'default' ? 'transparent' : 'transparent'
      }

      return 'transparent'
    },
    minWidth: pxToRem(24),
    minHeight: pxToRem(24),
    borderRadius: 24,
    fontWeight: '700',

    display: 'grid',
    placeItems: 'center',
    boxShadow: 'none',
    transition: transitions.create('margin', {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up('xl')]: {
      background: () => {
        let background

        if (!active) {
          background = transparentSidenav ? 'transparent' : 'transparent'
        } else if (sidenavColor === 'default') {
          background = 'transparent'
        } else if (sidenavColor === 'warning') {
          background = gradients.warning.main
        } else {
          background = 'transparent'
        }

        return background
      },
    },

    '& svg, svg g': {
      fill: active ? '#595B59' : '#A3A7AA',
      width: '24px',
      height: '24px',
    },

    i: {
      color: active ? '#595B59' : '#A3A7AA',
      fontSize: active ? '15px' : '16px',
    },
  }
}

const collapseIcon = ({ palette: { white, gradients } }, { active }) => ({
  color: active ? '#595B59' : '#A3A7AA',
})

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme
  const { miniSidenav, transparentSidenav, active } = ownerState

  const { size, fontWeightMedium, fontWeightRegular } = typography
  const { pxToRem } = functions

  return {
    marginLeft: pxToRem(12.8),
    [breakpoints.up('xl')]: {
      // opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      // maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : '100%',
      // marginLeft:
      // miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12.8),
      transition: transitions.create(['opacity', 'margin'], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    '& span': {
      fontWeight: active ? '700' : fontWeightRegular,

      fontSize: '18px',
      lineHeight: 0,
    },
  }
}

function collapseArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme
  const { noCollapse, transparentSidenav, miniSidenav, open } = ownerState

  const { dark, gradients, parco } = palette
  const { size } = typography
  const { pxToRem, rgba } = functions

  return {
    fontSize: `${size.md} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? 'rotate(0)' : 'rotate(-180deg)',
    color: dark.main,
    transition: transitions.create(['color', 'transform', 'opacity'], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),
    // breakpoint not necessary
    // [breakpoints.up('lg')]: {
    //   display:
    //     noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
    //       ? 'none !important'
    //       : 'block !important',
    // },

    display:
      noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
        ? 'none !important'
        : 'block !important',
  }
}

export {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
  collapseArrow,
}
